'use strict'

module.exports = {
    dataUtil: require('./dataUtil'),
    // consts: require('./addPanelDataConsts'),
    sections: require('./addPanelSections/index')
}